import DashboardOverviewModule from './DashboardOverview.module';

export default DashboardOverviewModule;
